// Availability write references used by the dated editor and PLT-011 explicit-send surface.
//
// Saving a browser draft never reaches this module. Only the person's later,
// deliberate "Send availability" tap calls `recordSelf`, which is boundary-wrapped
// and capability-checked in Convex (AVL-019, AUT-007).

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";
import type { Id } from "../../../../convex/_generated/dataModel";

export const availabilityMutations = {
  recordSelf: api.domain.availability.recordSelf,
  recordProxy: api.domain.availability.recordProxy,
  editSelf: api.domain.availability.editSelf,
  editProxy: api.domain.availability.editProxy,
  withdrawSelf: api.domain.availability.withdrawSelf,
  withdrawProxy: api.domain.availability.withdrawProxy,
} as const;

export type RecordAvailabilityResult = FunctionReturnType<typeof availabilityMutations.recordSelf>;
export type AvailabilityMutationResult =
  RecordAvailabilityResult | FunctionReturnType<typeof availabilityMutations.withdrawSelf>;

export function availabilityBatchDocumentId(value: string): Id<"availabilityBatches"> {
  return value as Id<"availabilityBatches">;
}

export function availabilityPersonDocumentId(value: string): Id<"people"> {
  return value as Id<"people">;
}
